import React, { useState, useEffect } from 'react';
import { Sidebar } from '../moderator/Sidebar';
import { Navbar } from '../Navbar';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../../config/config';

export function EditButcher() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [animalTypes, setAnimalTypes] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        butcherName: '',
        contactNumber: '',
        cnic: '',
        animalType: '',
        subCategory: '',
        rate: '',
        advance: '',
        address: ''
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const token = localStorage.getItem('token');
                const selectedYear = localStorage.getItem('qurbani_year') || new Date().getFullYear();

                const [typeRes, subRes, butcherRes] = await Promise.all([
                    fetch(`${config.baseUrl}/api/subcategories/filteranimal-type`, { headers: { 'Authorization': `Bearer ${token}` } }),
                    fetch(`${config.baseUrl}/api/subcategories/filtersubCat/${id}/?year=${selectedYear}`, { headers: { 'Authorization': `Bearer ${token}` } }),
                    fetch(`${config.baseUrl}/api/butcher/getButcherById/${id}`, { headers: { 'Authorization': `Bearer ${token}` } })
                ]);

                const typeData = await typeRes.json();
                const subData = await subRes.json();
                const butcherData = await butcherRes.json();
                
                setAnimalTypes(typeData);
                setSubCategories(subData);

                const b = butcherData.rows ? butcherData.rows[0] : (butcherData.butcher || butcherData);
                
                if (b && b[0]) {
                    setFormData({
                        butcherName: b[0].name || '',
                        contactNumber: b[0].contact || '',
                        cnic: b[0].cnic || '',
                        animalType: (b[0].category_id || '').toString(),
                        subCategory: (b[0].sub_cat_id || '').toString(),
                        rate: b[0].ageed_amt || '',
                        address: b[0].address || ''
                    });
                }
            } catch (error) {
                console.error("Failed to load edit data", error);
            }
        };
        fetchInitialData();
    }, [id]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.butcherName) newErrors.butcherName = "Required";
        if (!formData.contactNumber) newErrors.contactNumber = "Required";
        if (!formData.cnic) newErrors.cnic = "Required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'contactNumber' || name === 'cnic') {
            const cleaned = value.replace(/\D/g, '');
            setFormData(prev => ({ ...prev, [name]: cleaned }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${config.baseUrl}/api/butcher/editbutcher/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                navigate('/butcher/view');
            } else {
                alert("Update Failed");
            }
        } catch (error) {
            alert("Network Error");
        } finally {
            setLoading(false);
        }
    };

    return (
                <main className="">
                    <div className="max-w-5xl mx-auto">
                        {/* Main Form Card */}
                        <div className="bg-white rounded-[2.5rem] shadow-xl shadow-slate-200/60 border border-white overflow-hidden">
                            <div className="bg-indigo-900 px-10 py-10">
                                <h2 className="text-white font-black text-xs uppercase tracking-[0.3em]">Butcher Registration Data</h2>
                            </div>

                            <form onSubmit={handleSubmit} className="p-10">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
                                    <div className="space-y-2">
                                        <label className="block text-xs font-bold text-slate-600 uppercase ml-1">Full Name</label>
                                        <input name="butcherName" value={formData.butcherName} onChange={handleInputChange} type="text" className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-semibold focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none" />
                                        {errors.butcherName && <p className="text-[10px] text-red-500 font-bold ml-2 uppercase">Required Field</p>}
                                    </div>
                                    <div className="space-y-2">
                                        <label className="block text-xs font-bold text-slate-600 uppercase ml-1">Contact No</label>
                                        <input name="contactNumber" value={formData.contactNumber} onChange={handleInputChange} type="text" className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-semibold focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none" />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="block text-xs font-bold text-slate-600 uppercase ml-1">CNIC Identity</label>
                                        <input name="cnic" value={formData.cnic} onChange={handleInputChange} type="text" className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-semibold focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none" />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
                                    <div className="space-y-2">
                                        <label className="block text-xs font-bold text-slate-600 uppercase ml-1">Category</label>
                                        <select name="animalType" value={formData.animalType} onChange={handleInputChange} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold text-slate-700 focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none appearance-none">
                                            <option value="">Select</option>
                                            {animalTypes?.map(type => <option key={type.id} value={type.id}>{type.cat_name}</option>)}
                                        </select>
                                    </div>
                                    <div className="space-y-2">
                                        <label className="block text-xs font-bold text-slate-600 uppercase ml-1">Sub-Type</label>
                                        <select name="subCategory" value={formData.subCategory} onChange={handleInputChange} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold text-slate-700 focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none appearance-none">
                                            <option value="">Select</option>
                                            {subCategories?.map(sub => <option key={sub.sub_cat_id} value={sub.sub_cat_id}>{sub.subcat}</option>)}
                                        </select>
                                    </div>
                                    <div className="space-y-2">
                                        <label className="block text-xs font-bold text-slate-600 uppercase ml-1">Rate (PKR)</label>
                                        <input name="rate" value={formData.rate} onChange={handleInputChange} type="number" className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold text-blue-600 focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none" />
                                    </div>
                                </div>

                                <div className="space-y-2 mb-10">
                                    <label className="block text-xs font-bold text-slate-600 uppercase ml-1">Physical Address</label>
                                    <textarea name="address" value={formData.address} onChange={handleInputChange} rows="3" className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-semibold focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none resize-none" placeholder="Enter complete address details..."></textarea>
                                </div>

                                <div className="flex justify-end pt-8 border-t border-slate-100">
                                    <button 
                                        type="submit" 
                                        disabled={loading} 
                                        className="bg-blue-600 text-white px-12 py-4 rounded-2xl font-black text-xs uppercase tracking-[0.2em] shadow-xl shadow-blue-200 hover:bg-blue-700 transition-all active:scale-95 disabled:opacity-50"
                                    >
                                        {loading ? 'Processing...' : 'Update Butcher'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </main>

    );
}